import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { chatDrawerSelectors } from 'ducks/chatDrawer'
import { IconButton } from 'opensolar-ui'
import { useSelector } from 'react-redux'
import { useChatDrawerStyles } from '../ChatDrawer.styles'
import AdaProgressiveLoader from './AdaProgressiveLoader'
import { ChatSuggestions } from './ChatSuggestions'
import MessageBubble from './MessageBubble'

type ChatMessagesListProps = {
  messages: any[]
  showLoader: boolean
  showScrollButton: boolean
  hasNewMessages: boolean
  onScrollToBottom: () => void
  retryPending?: { messageIndex: number } | null
  shouldElevate?: boolean
  showCompactSuggestions?: boolean
}

const ChatMessagesList = (props: ChatMessagesListProps & { messagesContainerRef: React.RefObject<HTMLDivElement> }) => {
  const {
    messages,
    showLoader,
    showScrollButton,
    hasNewMessages,
    onScrollToBottom,
    messagesContainerRef,
    retryPending,
    shouldElevate = false,
    showCompactSuggestions = false,
  } = props
  const classes = useChatDrawerStyles()

  const failedMessageIndices = useSelector(chatDrawerSelectors.getFailedMessageIndices)

  // Show suggestions when there are no messages
  const showSuggestions = messages.length === 0 && !showLoader

  // Adjust button position when compact suggestions are visible
  // CompactSuggestions height is approximately 48px (8px padding top + ~32px button + 8px padding bottom)
  const compactSuggestionsOffset = showCompactSuggestions ? 55 : 0
  const buttonBottom = shouldElevate ? `${150 + compactSuggestionsOffset}px` : `${110 + compactSuggestionsOffset}px`

  return (
    <div ref={messagesContainerRef} className={classes.messagesContainer}>
      {showSuggestions ? (
        <ChatSuggestions />
      ) : (
        <>
          {messages.map((message, idx) => (
            <MessageBubble
              key={idx}
              message={message}
              isFailedSendMessage={failedMessageIndices.has(idx)}
              messageIndex={idx}
            />
          ))}
          {showLoader && <AdaProgressiveLoader />}
        </>
      )}
      {showScrollButton && messages.length > 0 && (
        <IconButton
          className={hasNewMessages ? classes.newMessageButton : classes.userScrollButton}
          onClick={onScrollToBottom}
          aria-label="Scroll to bottom"
          style={{ bottom: buttonBottom }}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
      )}
    </div>
  )
}

export default ChatMessagesList
